import React, { useState } from 'react';
import styles from './scss/settings.module.scss';
import ContentLayout from '../../layout/contentLayout';
import Connectors from './connectors/connectors';
import ApiConfiguration from './apiconfiguration/apiConfiguration';
import AddDomain from './apiconfiguration/addDomain';
import ImportCsv from './apiconfiguration/importCsv';
import Csat from './csat/scss/csat';
import Setupemail from './csat/setupemail';
import Setupwhatsapp from './csat/setupwhatsapp';
import Setupsms from './csat/setupsms';
import Domainconfig from './domainconfig/domainconfig';
import Email from './channelConfiguration/email';
// import Whatsappconfig from './channelConfiguration/whatsapp/whatsappconfig';
// import Smsconfig from './channelConfiguration/sms/smsconfig';
import WebPushConfig from './campaignChannelConfig/WebpushConfig';

import WhatsAppTemplates from './templates/whatsappTemplates';
import EmailConfig from './campaignChannelConfig/EmailConfig';
import AppPushConfig from './campaignChannelConfig/AppPushConfig';
import SmsConfig from './campaignChannelConfig/SmsConfig';
import WhatsAppConfig from './campaignChannelConfig/WhatsappConfig';


const Settings = () => {
    const [activeMenu, setActiveMenu] = useState({ activeHeader: 0, activeMenu: 0 });

    const settingTab = [
        {
            tabheader: 'Data Ingestion',
            tabmenu: [
                {
                    label: 'Connectors',
                    title: 'Connectors',
                    description: 'Integrate your data sources to build a unified customer view for precise segmentation and measurable value delivery.',
                    labelComp: <Connectors />
                },
                // {
                //     label: 'API configuration',
                //     title: 'API Configuration',
                //     description: 'Plug in your API, unlock smarter campaigns instantly.',
                //     labelComp: <ApiConfiguration />
                // },
                {
                    label: 'Import .csv files',
                    title: 'Import .csv files',
                    description: 'Import customer or transaction data using the supported file format.',
                    labelComp: <ImportCsv />
                }
            ]
        },
        {
            tabheader: 'Channel configuration',
            tabmenu: [
                {
                    label: 'Email',
                    // title: 'Email configuration',
                    // description: 'Manage and configure email addresses for communication and system notifications.',
                    labelComp: <EmailConfig />,
                    button: 'Add Email Address'
                },
                {
                    label: 'SMS',
                    // title: 'SMS configuration',
                    description: 'Configure and enable SMS for customer engagement and notifications.',
                    labelComp: <SmsConfig />,
                    button: 'Add Number'
                },
                {
                    label: 'WhatsApp',
                    // title: 'Whatsapp configuration',
                    description: 'Set up and manage WhatsApp as a communication channels for campaigns.',
                    // labelComp: <Whatsappconfig />,
                    labelComp: <WhatsAppConfig />,
                    button: 'Add Account'
                },
                // {
                //     label: 'Web Push',
                //     title: 'Web Push Configuration',
                //     description: 'Set up your website for push notifications.',
                //     labelComp: <WebPushConfig />
                // },
                {
                    label: 'App push',
                    // title: 'App Push Configuration',
                    // description: 'Set up your website for push notifications.',
                    labelComp: <AppPushConfig />
                }
            ]
        },
        // {
        //     tabheader: 'Basic Configuration',
        //     tabmenu: [
        //         {
        //             label: 'CSAT Configuration',
        //             title: 'CSAT Settings',
        //             description: 'Configure and customize your Customer Satisfaction survey.',
        //             labelComp: <Csat />
        //         },
        //     ]
        // },
        // {
        //     tabheader: 'Templates',
        //     tabmenu: [
        //         {
        //             label: 'Whatsapp',
        //             title: 'Whatsapp Templates',
        //             description: 'Manage and track your WhatsApp message templates for campaigns and customer communication.',
        //             labelComp: <WhatsAppTemplates />
        //         },
        //     ]
        // },
        // {
        //     tabheader: 'Domains & URL',
        //     tabmenu: [
        //         {
        //             label: 'Domain configuration',
        //             title: 'Domains',
        //             description: 'Authenticate your domain for trusted campaign delivery.',
        //             labelComp: <Domainconfig />
        //         }
        //     ]
        // },
    ];


    const handleTabChange = (headerIndex: number, menuIndex: number) => {
        if (document.startViewTransition) {
            document.startViewTransition(() => setActiveMenu({ activeHeader: headerIndex, activeMenu: menuIndex }))
        }
        else {
            setActiveMenu({ activeHeader: headerIndex, activeMenu: menuIndex })
        }


    }

    console.log("activemenuu", activeMenu)
    return (
        <ContentLayout noPadding={true} scrollset={true}>
            <div className={styles.settingssec}>
                <div className={styles.leftsettingstabsec}>

                    {settingTab.map((tab, headerIndex) => (
                        <div key={headerIndex} className={styles.tabblock}>
                            <div className={styles.tabblocktitle}>{tab.tabheader}</div>
                            <div className={styles.tabblockdesc}>
                                {tab.tabmenu.map((menu, menuIndex) => (
                                    <div key={menuIndex} className={`${styles.tabblockdescinner} ${(activeMenu.activeHeader === headerIndex && activeMenu.activeMenu === menuIndex) ? styles.activemenuitem : ''}`} onClick={() => handleTabChange(headerIndex, menuIndex)}>{menu.label}</div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
                <div className={`${styles.rightsettingsmenu} rightsettingsmenu`}>

                    {settingTab[activeMenu.activeHeader].tabmenu[activeMenu.activeMenu].title &&
                        <div className={styles.titlearea}>
                            <div className={styles.titlearealeft}>
                                <div className={styles.titlename}>{settingTab[activeMenu.activeHeader].tabmenu[activeMenu.activeMenu].title}</div>
                                <div className={styles.titledesc}>{settingTab[activeMenu.activeHeader].tabmenu[activeMenu.activeMenu].description}</div>
                            </div>
                            <div className={styles.titlearearight}>
                                {settingTab[activeMenu.activeHeader].tabmenu[activeMenu.activeMenu].button ? <button>{settingTab[activeMenu.activeHeader].tabmenu[activeMenu.activeMenu].button}</button> : ""}
                            </div>
                        </div>
                    }

                    {settingTab[activeMenu.activeHeader].tabmenu[activeMenu.activeMenu].labelComp}
                </div>
            </div>

        </ContentLayout>
    )
}

export default Settings
